import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"

type Props = {
  companyId: string
  onSuccess?: (canonicalTopicId: string) => void
}

export const useCreateCanonicalTopicFromSnapshotMutation = ({ companyId, onSuccess }: Props) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ clusterSnapshotId }: { clusterSnapshotId: string }) => {
      const { data } = await axios.post<{
        data: { id: string; label: string; description: string | null }
      }>("/backoffice/canonicalTopics/create-from-snapshot", {
        companyId,
        clusterSnapshotId,
      })
      return data.data
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ["backofficeClusterSnapshots", companyId],
      })
      queryClient.invalidateQueries({
        queryKey: ["backofficeCanonicalTopicsGrouped", companyId],
      })
      onSuccess?.(data.id)
    },
  })
}
